import { storageRepository } from '@betgames/bg-tools';
import SessionStore from './Session.store';

export const sessionStore = new SessionStore(storageRepository);
